module.exports = __webpack_public_path__ + "assets/img/enterprise-domain-why-icon-2.e8b19ec8.png";